export const VIEW_INIT = 'VIEW_INIT'
export const VIEW_SAVE = 'VIEW_SAVE'
export const VIEW_UPDATE = 'VIEW_UPDATE'
export const VIEW_SELECT_TAB = 'VIEW_SELECT_TAB'
